module.exports = __webpack_public_path__ + "img/img002.fddb4064.png";